module.exports = __webpack_public_path__ + "img/msg_black.71dd455d.png";